import React, { ReactNode, useMemo, useState } from 'react';

interface RenderPageNotFoundStore {
  shouldRender: boolean;
  renderPageNotFound: (shouldRender: boolean) => void;
}

export const RenderPageNotFoundContext =
  React.createContext<RenderPageNotFoundStore>({
    shouldRender: false,
    renderPageNotFound: () => {},
  });

export const RenderPageNotFoundProvider: React.FC<
  React.PropsWithChildren<{ children: ReactNode }>
> = ({ children }) => {
  const [shouldRender, setShouldRender] = useState<boolean>(false);

  const renderPageNotFoundStore: RenderPageNotFoundStore = useMemo(
    () => ({
      shouldRender,
      renderPageNotFound: setShouldRender,
    }),
    [shouldRender],
  );

  return (
    <RenderPageNotFoundContext.Provider value={renderPageNotFoundStore}>
      {children}
    </RenderPageNotFoundContext.Provider>
  );
};
